import React, { ReactNode } from 'react';
import {
  Paper,
  Slide,
  PaperProps,
  SxProps,
  Theme,
  Box
} from '@mui/material';

interface AnimatedFooterProps extends Omit<PaperProps, 'children'> {
  show?: boolean;
  children: ReactNode;
  elevation?: number;
  borderRadius?: number;
  padding?: number | string;
  sx?: SxProps<Theme>;
}

const AnimatedFooter: React.FC<AnimatedFooterProps> = ({
  show = false,
  children,
  elevation = 5,
  borderRadius = 24,
  padding = 2,
  sx,
  ...otherProps
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '1rem',
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: show ? 'auto' : 'none'
      }}
    >
      <Slide direction="up" in={show} timeout={{ enter: 200, exit: 150 }}>
        <Paper
          elevation={elevation}
          sx={{
            minWidth: '40rem',
            padding,
            borderRadius: borderRadius,
            zIndex: 1100,
            ...sx
          }}
          {...otherProps}
        >
          {children}
        </Paper>
      </Slide>
    </Box>
  );
};

export default React.memo(AnimatedFooter);